export default {
  picker: {
    cancel: '取消',
    confirm: '确认',
  },
};
